module.exports = {"Device":"دریافت تردد از {{deviceName}}","Device Data":"همه ترددها:{{all}} - تردد های جدید:{{new}}"}